import { supabase } from './supabase'
import { getTenantConfig } from './tenant-config'

const tenantConfig = getTenantConfig()
const SUPABASE_URL = tenantConfig.supabase.url

interface SendEmailParams {
  type: 'doi' | 'welcome' | 'invitation' | 'password_reset' | 'test_doi' | 'test_welcome'
  to: string
  data: Record<string, unknown>
}

export async function sendEmail(params: SendEmailParams) {
  const response = await fetch(`${SUPABASE_URL}/functions/v1/email-worker`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${(await supabase.auth.getSession()).data.session?.access_token || ''}`,
    },
    body: JSON.stringify({
      ...params,
      // Mandanten-spezifischer E-Mail-Absender
      email_from: `${tenantConfig.email_from_name} <${tenantConfig.email_from}>`,
      tenant_name: tenantConfig.branding.name,
    }),
  })

  if (!response.ok) {
    const error = await response.json()
    throw new Error(error.error || 'Failed to send email')
  }

  return response.json()
}

export async function sendDoiEmail(leadId: string, eventId: string, email: string, confirmationUrl: string) {
  return sendEmail({
    type: 'doi',
    to: email,
    data: {
      leadId,
      eventId,
      confirmationUrl,
    },
  })
}

export async function sendWelcomeEmail(leadId: string, eventId: string, email: string) {
  return sendEmail({
    type: 'welcome',
    to: email,
    data: {
      leadId,
      eventId,
    },
  })
}
